import React, { createContext, useContext, useState, useEffect } from 'react';
import { connect } from 'react-redux'

const New2026CheckoutContext = createContext({
    promoData: null,
    isLoadingPromoData: false
});

const isPromoEnabledPage = () => {
    const url = window.location.href.toLowerCase();
    return url.includes('shoppingcart') || url.includes('customerinfo');
};

const New2026CheckoutProviderInternal = ({ children, lineItemsSubtotal }) => {
    const [promoData, setPromoData] = useState(null);
    const [isLoadingPromoData, setIsLoadingPromoData] = useState(false);

    useEffect(() => {
        if (!isPromoEnabledPage()) return;
        if (!lineItemsSubtotal) return;
        setIsLoadingPromoData(true);
        
        if (window.location.href.includes('localhost')) {
             setTimeout(() => {
                setPromoData({
                    anyThingToShow: true,
                    preDiscountSubTotal: { decimal: 1098.99, string: "$1,098.99" },
                    totalDiscountAmount: { decimal: 10, string: "$10.00" },
                    postDiscountSubTotal: { decimal: 1088.99, string: "$1,088.99" },
                    discountMessage: "Includes PDP_TEST_PROMO_1",
                    expiresOn: "2025-12-04T06:00:00Z"
                });
                setIsLoadingPromoData(false);
            }, 1000);
            return;
        }
        
        fetch("/api/checkout/cart/promotions", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({})
        })
        .then(res => res.json())
        .then(data => {
            setPromoData(data);
            setIsLoadingPromoData(false);
        })
        .catch(err => {
            console.error("Error fetching promo data", err);
            setIsLoadingPromoData(false);
        });
    }, [lineItemsSubtotal]);
    return (
        <New2026CheckoutContext.Provider value={{ promoData, isLoadingPromoData }}>
            {children}
        </New2026CheckoutContext.Provider>
    );
};

const mapStateToProps = (state) => {

    return {
        lineItemsSubtotal: state.orderDetails?.lineItemsSubtotal ?? ""
    }
}

export const New2026CheckoutProvider = connect(mapStateToProps)(New2026CheckoutProviderInternal);

export const useNew2026Checkout = () => useContext(New2026CheckoutContext);
export { New2026CheckoutContext, isPromoEnabledPage };

